var exports = {
  "wm": "xfd349460--157c88--logo",
  "nf": "xfd349460--157c88--link",
  "Pf": "xfd349460--157c88--label",
};

module.exports = exports;
